import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PrologueImage from "../../components/PrologueImage";
import SegmentedControl from "../../components/SegmentedControl";
import OngoingResearch from "./OngoingResearch";
import Publications from "./Publications";

export default function Research() {
  const { t } = useTranslation();
  const { lng } = useParams();

  const tabs = [
    { path: "ongoing-research", component: <OngoingResearch /> },
    { path: "publications", component: <Publications /> },
  ];

  return (
    <>
      <Helmet>
        <title>{`${t("research")} | PEL Group`}</title>
        <meta name="description" content={t("researchIntro")} />
      </Helmet>
      <Box style={{ position: "relative" }}>
        <PrologueImage
          title={t("research")}
          subtitle={t("researchIntro")}
          image="/home-carousel-2.jpg"
        />
        <SegmentedControl options={tabs.map((tab) => tab.path)} top="80%" />
      </Box>
      <Routes>
        {tabs.map((tab) => (
          <Route key={tab.path} path={tab.path} element={tab.component} />
        ))}
        <Route
          path="*"
          element={
            <Navigate
              to={`/${lng ?? "en"}/research/${tabs[0].path}`}
              replace
            />
          }
        />
      </Routes>
    </>
  );
}
